import { useCallback } from "react";
import { useDispatch } from "react-redux";
import {
  loanDrilldownClear,
  loanDrilldownSet,
} from "../redux/actions/loanDrilldownActions";
import { sidebarReset } from "../redux/actions/sidebarActions";
import { loanFetchedDataClearAll } from "../redux/reducers/loanFetchedDataReducer";
import { useUnderwritingHook } from "./useUnderwritingHook";
import { detailSidebarClear } from "../redux/reducers/detailSidebarReducer";

export const useReduxLoanDrilldownHook = () => {
  const dispatch = useDispatch();
  const { getLoanById } = useUnderwritingHook();
  const clearLoanDrilldownData = useCallback(() => {
    dispatch(loanFetchedDataClearAll());
    dispatch(sidebarReset());
    dispatch(detailSidebarClear());
    dispatch(loanDrilldownClear());
  }, []);

  const clearLoanDrilldownSidebarData = useCallback(() => {
    dispatch(sidebarReset());
  }, []);

  const clearLoanDrilldownFetchedData = useCallback(() => {
    dispatch(loanFetchedDataClearAll());
  }, []);

  const clearLoanDrilldownMeta = useCallback(() => {
    dispatch(loanFetchedDataClearAll());
    dispatch(sidebarReset());
  }, []);

  const clearFetchSetLoanDrilldown = useCallback(({ loanId }) => {
    clearLoanDrilldownData();
    getLoanById({
      loanId,
      // Cold load (the state was just cleared above), so the stale-read guard
      // has nothing to protect — see utils/loan/loanWriteSeq.js.
      allowStale: true,
      onSuccessFn: (data) => {
        dispatch(loanDrilldownSet(data));
      },
      onFailFn: () => dispatch(loanDrilldownSet({})),
    });
  }, []);

  return {
    clearLoanDrilldownData,
    clearLoanDrilldownSidebarData,
    clearLoanDrilldownFetchedData,
    clearLoanDrilldownMeta,
    clearFetchSetLoanDrilldown,
  };
};
